import Quill from 'quill';
import '@shoelace-style/shoelace'
import './lite-yt-embed.js';
import './play.js';

const visibilityRadios = document.querySelectorAll('input[name="visibility"]')
const participantsEl = document.querySelector('.Inputfield_participants')
if (visibilityRadios) {
  visibilityRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      const selectedValue = radio.value
      if (selectedValue === 'private_users') {
        participantsEl.classList.add('fade-in')
      } else {
        participantsEl.classList.remove('fade-in')
      }
    })
  })
}


const dialogs = document.querySelectorAll('.dialog-overview');
dialogs.forEach(dialog => {
  const openButton = dialog.nextElementSibling || document.querySelector('.edit-body-button');
  const closeButton = dialog.querySelector('sl-button[slot="footer"]');

  openButton.addEventListener('click', () => {
    dialog.show();
  });
  closeButton.addEventListener('click', () => dialog.hide());
});



const drawer = document.querySelector('.drawer-overview');
if (drawer) {
  const openButton = drawer.nextElementSibling;
  const closeButton = drawer.querySelector('sl-button[variant="default"]');

  openButton.addEventListener('click', () => drawer.show());
  closeButton.addEventListener('click', () => drawer.hide());
}




// quill
document.addEventListener('DOMContentLoaded', function() {
  // Create a div for Quill
  var textareas = document.querySelectorAll('[id^=wysiwyg-]');
  textareas.forEach(function(textarea) {

    var quillContainer = document.createElement('div');
    quillContainer.style.height = '300px'; // Set editor height
    textarea.parentNode.insertBefore(quillContainer, textarea);
    textarea.style.display = 'none'; // Hide textarea

    // Initialize Quill
    var quill = new Quill(quillContainer, {
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],
        ],
      },
    });

    quill.root.innerHTML = textarea.value;
    // Sync Quill content to textarea on form submit
    quill.on('text-change', function() {
      textarea.value = quill.root.innerHTML;
    });
  })
});

// avoid re-submitting the form on page refresh
if ( window.history.replaceState ) {
    window.history.replaceState( null, null, window.location.href );
}


const embeds = document.querySelectorAll("lite-youtube");
if (embeds.length > 0) {
  observeEmbeds()
}

function observeEmbeds() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // If the element is not in the viewport
      if (!entry.isIntersecting) {
        // Remove the iframe containing the YouTube player
        const iframe = entry.target.querySelector("iframe");
        entry.target.classList.remove("lyt-activated");
        // entry.target.classList.remove("in-view");
        if (iframe) {
          iframe.remove();
        }
      }
      // else {
      //   entry.target.classList.add("in-view");
      // }
    });
  });
  // Start observing the lite-youtube elements
  embeds.forEach((el) => observer.observe(el));
}
